'use client';

import { FC } from 'react';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { Container } from '@purpur/library';

import { RichTextContent } from '@telialt/common-rich-text-content/src/RichTextContent';

import { BlockTextType } from '../../models/Content';
import { getBlockId } from '../../utils/content';
import { BlockWrapper } from './BlockText.styles';
import { transformBlockText } from './transformers';

type Props = {
    contentItem: BlockTextType;
};

export const BlockText: FC<Props> = ({ contentItem: initialContentItem }) => {
    const contentItem = useContentfulLiveUpdates(initialContentItem);
    const transformedContentItem = transformBlockText(contentItem);

    return (
        <BlockWrapper $colorOption={transformedContentItem.colorOption} id={getBlockId(contentItem)}>
            <Container>
                <RichTextContent richText={transformedContentItem.description} />
            </Container>
        </BlockWrapper>
    );
};
